export default "__VITE_ASSET__C_6$qgGn__"